var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cursor-pointer p-4 text-center block max-w-4",class:_vm.styleClass},[_c('icon',{class:_vm.iconClass,attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }